import { RedoIncrementDecrement } from "@redotech/redo-web/arbiter-components/increment-decrement/redo-increment-decrement";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const TimePicker = memo(function TimePicker({
  hours,
  minutes,
  setHours,
  setMinutes,
}: {
  hours: number;
  minutes: number;
  setHours: (hours: number) => void;
  setMinutes: (minutes: number) => void;
}) {
  return (
    <Flex align="center" dir="row" gap="xs">
      <RedoIncrementDecrement
        max={23}
        min={0}
        minimumDisplayDigits={2}
        setValue={setHours}
        size="small"
        step={1}
        value={hours}
      />
      <Text fontSize="sm" fontWeight="medium" textColor="primary">
        :
      </Text>
      <RedoIncrementDecrement
        max={59}
        min={0}
        minimumDisplayDigits={2}
        setValue={setMinutes}
        size="small"
        step={1}
        value={minutes}
      />
    </Flex>
  );
});
